import Prefixer from 'inline-style-prefixer';
import styled from 'react-emotion';
import { colors } from '@ublend-npm/aulaui-next-web/themes/default';

const createPostStyle = new Prefixer().prefix({
  wrapper: {
    display: 'flex',
    marginTop: 32,
    position: 'relative',
  },
  container: {
    position: 'relative',
    width: '100%',
    maxWidth: 900,
    minWidth: 300,
    padding: '0px 25px',
    borderRadius: 6,
    boxShadow: '0px 2px 8px 0px rgba(0, 0, 0, 0.3)',
    backgroundColor: 'white',
  },
  editorWrapper: {
    borderRadius: 6,
    border: '1px black',
    marginLeft: 'auto',
    marginRight: 'auto',
    position: 'relative',
    padding: '25px 0',
  },
  separator: {
    backgroundColor: colors.grayLight,
    height: 3,
    position: 'relative',
    marginLeft: -25,
    width: 'calc(100% + 50px)',
    marginTop: 30,
    marginBottom: 30,
  },
  editor: {
    whiteSpace: 'normal',
  },
  postButtonWrapper: {
    position: 'relative',
    marginRight: 70,
  },
  postButtonContainer: {
    width: 110,
    marginLeft: 20,
    height: 50,
  },
  postButton: {
    width: 110,
    height: 50,
  },
  postButtonLabel: {
    textTransform: 'none',
    fontSize: 18,
    padding: '30px 20px',
  },
});

export const PostIdeasContainer = styled('div')`
  padding-left: 54px;
  padding-bottom: 25px;
  font-size: 14px;
  font-weight: 500;
`;

export const PostIdeasLink = styled('a')`
  color: ${colors.green0};
  :link {
    text-decoration: none;
  }
  :hover {
    text-decoration: underline;
  }
`;

export default createPostStyle;
